export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/22bc74ca-5be5-4c32-b5c0-1fc1ade113ea/OtAutoBlock.js',
  domainScript: '22bc74ca-5be5-4c32-b5c0-1fc1ade113ea',
};
